var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.itemsAsideMenu),function(itemAside,index){return _c('li',{key:index},[_c('router-link',{class:itemAside.class,attrs:{"to":itemAside.to}},[_c('span',{staticClass:"m-item-aside-icon"},[_c('i',{class:itemAside.icon})]),_c('span',[_vm._v(_vm._s(itemAside.text))])])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }